import { render, staticRenderFns } from "./SelectSwitcher.vue?vue&type=template&id=181e4b7b"
import script from "./SelectSwitcher.vue?vue&type=script&lang=js"
export * from "./SelectSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports